import { FC, isValidElement, ReactElement } from 'react'

import { TagsNoRef } from '@trustycars/genie-ui/types'
import { propsWithClassNames } from '@trustycars/genie-ui/functions'

import { container, separator, label as labelStyle } from './styles.css'

type SeparatorWithLabelProps = {
  label: string | ReactElement
  separatorProps?: TagsNoRef<'span'>
  labelProps?: TagsNoRef<'p'>
  containerProps?: TagsNoRef<'div'>
}

export const SeparatorWithLabel: FC<SeparatorWithLabelProps> = ({
  label,
  separatorProps,
  labelProps,
  containerProps
}) => (
  <div {...propsWithClassNames(containerProps, container)}>
    <hr {...propsWithClassNames(separatorProps, separator)} />
    {isValidElement(label) ? (
      label
    ) : (
      <p {...propsWithClassNames(labelProps, labelStyle)}>{label}</p>
    )}

    <hr {...propsWithClassNames(separatorProps, separator)} />
  </div>
)

export default SeparatorWithLabel
